import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { getFromLocalStorage, saveToLocalStorage } from '../mock';
import { Car, LogIn } from 'lucide-react';
import { toast } from '../hooks/use-toast';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const BACKEND_URL = ''; // same-origin: reverse proxy routes /api/* to backend
      
      // Call backend API
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (!response.ok) {
        toast({ 
          title: "Giriş Başarısız", 
          description: data.detail || "Email veya şifre hatalı.",
          variant: "destructive"
        });
        return;
      }

      // Save user data and token
      saveToLocalStorage('currentUser', data.user);
      saveToLocalStorage('accessToken', data.access_token);
      
      if (rememberMe) {
        saveToLocalStorage('rememberMe', true);
      }


      toast({ 
        title: "Hoş geldiniz!", 
        description: data.user.isAdmin ? "Admin paneline yönlendiriliyorsunuz..." : "Panelinize yönlendiriliyorsunuz..."
      });
      
      // Navigate based on user type
      setTimeout(() => {
        if (data.user.isAdmin || data.user.role === 'admin' || data.user.role === 'manager') {
          navigate('/admin');
        } else if (data.user.isStaff || data.user.role === 'sales' || data.user.role === 'technician') {
          navigate('/admin');
        } else {
          navigate('/dashboard');
        }
      }, 500);
    } catch (error) {
      console.error('Login error:', error);
      toast({ 
        title: "Hata", 
        description: "Giriş sırasında bir hata oluştu. Lütfen tekrar deneyin.",
        variant: "destructive"
      });
    }
  };

  return (
    <div className="min-h-screen bg-background text-foreground flex items-center justify-center p-5 grid-bg relative">
      <div className="w-full max-w-md fade-up">
        <div className="flex justify-center mb-8">
          <img src="/art-garage-logo.png" alt="ART Garage" className="h-20 w-auto" />
        </div>

        <div className="card-premium rounded-2xl p-8">
          <div className="mb-6 text-center">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand mb-2">
              -- Giris
            </div>
            <h1 className="font-display font-extrabold text-3xl tracking-tight">
              Hos Geldin
            </h1>
            <p className="text-muted-foreground text-sm mt-2">
              Hesabina giris yap
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
                Email
              </Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                required
                className="bg-surface-2 hairline"
                data-testid="login-email"
              />
            </div>

            <div className="space-y-1.5">
              <Label className="text-xs font-mono uppercase tracking-wider text-muted-foreground">
                Sifre
              </Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-surface-2 hairline"
                data-testid="login-password"
              />
            </div>

            <div className="flex items-center justify-between pt-1">
              <label className="flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
                <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
                Beni Hatirla
              </label>
              <Link to="/forgot-password" className="text-xs text-brand hover:underline">
                Sifremi unuttum
              </Link>
            </div>

            <button
              type="submit"
              className="cta-brand w-full h-11 rounded-lg mt-2 inline-flex items-center justify-center gap-2"
              data-testid="login-submit"
            >
              Giris Yap
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-muted-foreground">
            Hesabin yok mu?{' '}
            <Link to="/register" className="text-brand hover:underline">Kayit ol</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;